/**
 * 形状图层命令（M3-15 / DESIGN.md §6.3）。
 *
 * 形状图层没有像素（同调整/文本图层的「非破坏优先」纪律），改的只是
 * PathData 字符串——结构命令，逆操作存旧路径，成本几十字节。
 */
import type { Command, Json } from '../command-bus';
import { findLayer, layerDefaults } from '../../document/draft';
import type { LayerId, PathData, ShapeLayer, VectorFill, VectorStroke } from '../../document/types';

const STRUCTURAL_COST = 128;

export function createShapeLayer(
  id: LayerId,
  name: string,
  path: PathData,
  fill: VectorFill = { type: 'solid', color: '#808080' },
  stroke?: VectorStroke,
): ShapeLayer {
  return { ...layerDefaults(id, name), kind: 'shape', path, fill, ...(stroke === undefined ? {} : { stroke }) };
}

export function createSetShapePathCommand(id: LayerId, path: PathData): Command {
  return {
    kind: 'shape.setPath',
    label: '编辑路径',
    cost: STRUCTURAL_COST,
    // `PathData` 没有索引签名，但字段全是纯数据；转换是精确类型，不是 any
    record: { kind: 'shape.setPath', args: { id, path } as unknown as Readonly<Record<string, Json>> },
    apply(draft) {
      draft.updateLayer(id, (layer) =>
        layer.kind === 'shape' ? { ...layer, path } : layer,
      );
    },
    invert(document) {
      const found = findLayer(document.root, id);
      if (found === null || found.layer.kind !== 'shape') return null;
      return createSetShapePathCommand(id, found.layer.path);
    },
  };
}
